<template>
    <div class="restore-page" v-loading="isGenerating">
        <div class="col">
            <div class="box" @click="triggerFileSelect('effect')">
                <div v-if="!effectImagePreview">
                    <img src="../images/upload.png" alt="">
                    <div class="box-text">请上传效果图</div>
                    <div class="box-text">支持 拖拽/点击上传图片</div>
                    <div class="box-brief">或从 <div class="box-lishi">历史创作</div> 中选择</div>
                    <div class="box-brief">支持10MB图片,PNG、JPG、JPEG格式分辨率>512*512</div>
                </div>
                <div v-else class="preview-container">
                    <img :src="effectImagePreview" alt="效果图预览" class="preview-image">
                    <div class="change-image">点击更换图片</div>
                </div>
            </div>
            <div class="box mt24" @click="triggerFileSelect('site')">
                <div v-if="!siteImagePreview">
                    <img src="../images/upload.png" alt="">
                    <div class="box-text">请上传现场图</div>
                    <div class="box-text">支持 拖拽/点击上传图片</div>
                    <div class="box-brief">支持10MB图片,PNG、JPG、JPEG格式分辨率>512*512</div>
                </div>
                <div v-else class="preview-container">
                    <img :src="siteImagePreview" alt="现场图预览" class="preview-image">
                    <div class="change-image">点击更换图片</div>
                </div>
            </div>
            <div class="btn" @click="handleAiModify">
                <div class="btn-title">AI修改</div>
                <div class="btn-brief">（生成消耗5积分）</div>
            </div>
        </div>
        <div class="col-right">
            <div class="content" v-if="!aiResult && !isGenerating">
                <img class="content-logo" src="../images/content.png" alt="">
                <div class="content-title">暂无AI融合</div>
            </div>
            <div class="content" v-else-if="isGenerating">
                <div class="generating-container">
                    <div class="spinner"></div>
                    <div class="generating-text">AI正在生成中，请稍候...</div>
                </div>
            </div>
            <div class="content" v-else>
                <img :src="aiResult.image_url" alt="AI生成结果" class="result-image">
                <div class="result-actions">
                    <button class="action-btn download-btn" @click="downloadResult">下载</button>
                    <button class="action-btn regenerate-btn" @click="regenerateResult">重新生成</button>
                </div>
            </div>
            <div class="right-brief">
                <img class="right-brief-logo" src="../images/warning.png" alt="">
                <div class="right-brief-title">门头现场照片须清晰干净无杂物，暂不支持异形结构，否则无法生成</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus'
// 获取store和provide
const store = useStore();
const openLoginDialog = inject('openLoginDialog', null);

// 图片上传相关状态
const effectImage = ref(null); // 效果图
const siteImage = ref(null); // 现场图
const effectImagePreview = ref(''); // 效果图预览
const siteImagePreview = ref(''); // 现场图预览
const effectImagePreview1 = ref(''); // 效果图预览
const siteImagePreview1 = ref(''); // 现场图预览

// AI 生成结果
const aiResult = ref(null);
// 生成状态
const isGenerating = ref(false);

// 自定义 loading 配置
const customLoadingOptions = {
    text: '图片正在生成中...',
    background: 'rgba(0, 0, 0, 0.7)',
    spinner: `<div class="custom-spinner"></div>`,
    lock: true,
    fullscreen: false
};
// 处理文件上传
const handleFileUpload = async (event, type) => {
    const file = event.target.files[0];
    console.log(file);

    if (!file) return;

    // 验证文件类型
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
        ElMessage.error('只支持PNG、JPG、JPEG格式的图片');
        return;
    }

    // 验证文件大小 (10MB)
    if (file.size > 10 * 1024 * 1024) {
        ElMessage.error('图片大小不能超过10MB');
        return;
    }

    // 设置预览
    const reader = new FileReader();
    reader.onload = (e) => {
        console.log(e, 'eeeeeeeeee');

        if (type === 'effect') {
            effectImagePreview.value = e.target.result;
            effectImage.value = file;
        } else {
            siteImagePreview.value = e.target.result;
            siteImage.value = file;
        }
    };
    reader.readAsDataURL(file);

    // 上传图片到服务器
    try {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('type', type);
        console.log(formData, 'formData');

        const response = await store.dispatch('uploadImage', formData);
        ElMessage.success(`${type}图片上传成功`);
        if (type === 'effect') {
            effectImagePreview1.value = response.data.data.url;
            effectImage.value = file;
        } else {
            siteImagePreview1.value = response.data.data.url;
            siteImage.value = file;
        }
        // 这里可以保存返回的图片URL
        // 例如：如果type是'effect'，则保存response.data.url到某个状态中
    } catch (error) {
        ElMessage.error(`${type}图片上传失败`);
    }
};

// 触发文件选择
const triggerFileSelect = (type) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png,image/jpg';
    fileInput.onchange = (e) => handleFileUpload(e, type);
    fileInput.click();
};

// 检查用户是否已登录
const checkLogin = async () => {
    if (!store.getters.isLoggedIn) {
        // 用户未登录，显示提示
        ElMessage({
            message: '暂未登录',
            type: 'warning',
            duration: 3000
        });

        // 打开登录弹窗
        if (openLoginDialog) {
            openLoginDialog('login');
        }
        return false;
    }
    return true;
}

// AI修改
const handleAiModify = async () => {
    // 检查是否正在生成中，防止重复点击
    if (isGenerating.value) {
        ElMessage({
            message: '正在生成中，请稍候...',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    if (!(await checkLogin())) return;

    // 检查是否已上传图片
    if (!effectImage.value || !siteImage.value) {
        ElMessage({
            message: '请先上传效果图和现场图',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    // 检查积分是否足够（生成需要 10 积分）
    const requiredPoints = 5;
    const currentPoints = store.getters.userInfo?.points || store.getters.userInfo?.credit || 0;

    if (currentPoints < requiredPoints) {
        ElMessage({
            message: '积分不足，请先充值',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    // 生成前提示 - 使用确认弹窗
    try {
        await ElMessageBox.confirm(
            '本次操作将消耗 5 积分，是否继续？',
            '积分扣除确认',
            {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }
        );
    } catch (cancelError) {
        // 用户点击取消或关闭弹窗
        return;
    }

    // 设置自定义 loading（页面级 loading）
    isGenerating.value = customLoadingOptions;
    aiResult.value = null;

    try {
        // 构造请求数据
        const requestData = {
            effectImageUrl: effectImagePreview1.value,
            siteImageUrl: siteImagePreview1.value,
            sequential_image_generation: "auto",
            sequential_image_generation_options: {
                max_images: 4
            }
        };

        // 调用 store action 进行 AI修改
        const response = await store.dispatch('aiModify', requestData);
        console.log('AI修改成功:', response);

        // 存储生成结果
        aiResult.value = response.data.data;

        // 生成成功后，重新获取用户信息以更新积分
        try {
            await store.dispatch('getCurrentUser');
            // 生成成功后提示
            ElMessage({
                message: '已扣除 10 积分',
                type: 'success',
                duration: 2000
            });
        } catch (error) {
            console.error('更新用户信息失败:', error);
        }
    } catch (error) {
        console.error('AI修改失败:', error);

        // 使用拦截器设置的友好错误提示
        if (error.friendlyMessage) {
            ElMessage({
                message: error.friendlyMessage,
                type: 'error',
                duration: 3000
            });
        }
        // 检查是否是因为用户未登录导致的错误
        else if (error.message === '用户未登录') {
            ElMessage({
                message: '请先登录以使用 AI修改功能',
                type: 'warning',
                duration: 3000
            });
        }
    } finally {
        // 无论成功还是失败，都将生成状态设置为 false
        isGenerating.value = false;
    }
}

// 下载生成结果
const downloadResult = () => {
    if (!aiResult.value || !aiResult.value.image_url) {
        ElMessage({
            message: '没有可下载的内容',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    // 创建一个临时的a标签用于下载
    const link = document.createElement('a');
    link.href = aiResult.value.image_url;
    link.download = 'ai-generated-image.png';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// 重新生成
const regenerateResult = async () => {
    // 直接重新调用AI修改函数
    await handleAiModify();
};
</script>

<style scoped>
.content {
    margin-left: 40px;
    width: 633px;
    height: 493px;
    background: #1D1D1D;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #6A6B6E;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    justify-content: center;
}

.result-image {
    max-width: 100%;
    max-height: calc(100% - 60px);
    /* 为按钮留出空间 */
    object-fit: contain;
    flex-shrink: 0;
}

.generating-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #5EFF00;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.generating-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
}

.result-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: auto;
    padding: 20px 0;
    flex-shrink: 0;
}

.action-btn {
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
}

.download-btn {
    background-color: #5EFF00;
    color: #222222;
}

.regenerate-btn {
    background-color: #2B2C2C;
    color: #FFFFFF;
    border: 1px solid #6A6B6E;
}

.content-logo {
    width: 48px;
    height: 48px;
}

.content-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #666666;
    margin-top: 8px;
}

.right-brief-logo {
    width: 18px;
    height: 18px;
}

.right-brief-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 8px;
}

.right-brief {
    display: flex;
    align-items: center;
    margin-top: 16px;
}

.restore-page {
    color: white;
    padding: 20px;
    display: flex;
    align-items: center;
}

.col-right {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.box-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    margin-top: 8px;
    text-align: center;
}

.box-brief {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 12px;
    color: #666666;
    display: flex;
    margin-top: 8px;
}

.box-lishi {
    color: #5EFF00 !important;
}

.box {
    width: 490px;
    height: 202px;
    background: #1D1D1D;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #6A6B6E;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.preview-image {
    max-width: 100%;
    max-height: 160px;
    object-fit: contain;
}

.change-image {
    margin-top: 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 12px;
    color: #5EFF00;
}

.mt24 {
    margin-top: 24px;
}

.btn {
    width: 490px;
    height: 66px;
    background: #5EFF00;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #00FBFF;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
}

.btn-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #222222;
}

.btn-brief {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #328800;
}

.col {
    display: flex;
    flex-direction: column;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
    .restore-page {
        flex-direction: column;
        align-items: stretch;
        padding: 10px;
    }

    .content {
        width: 100%;
        max-width: 633px;
        height: 400px;
        margin-left: 0;
        margin-top: 16px;
    }

    .col-right {
        width: 100%;
        margin-top: 16px;
    }

    .box {
        width: 100%;
        max-width: 490px;
    }

    .btn {
        width: 100%;
        max-width: 490px;
    }

    .result-actions {
        flex-wrap: wrap;
        gap: 10px;
    }

    .action-btn {
        flex: 1;
        min-width: 120px;
    }
}

/* 自定义 loading 样式 */
.custom-spinner {
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #5EFF00;
    animation: custom-spin 1s ease-in-out infinite;
}

@keyframes custom-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
